export const REDUCER_NAME = 'detail'



// WEBPACK FOOTER //
// ./src/modules/appointment/state/detail/const.js